import React, { useState } from "react";
import { auth } from "../../firebase/FirebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const loginHandler = async () => {
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/admin-dashboard");
        } catch (error) {
            alert("Login failed: " + error.message);
        }
    };

    return (
        <div
            className="d-flex justify-content-center align-items-start"
            style={{
                minHeight: "100vh",
                paddingTop: "140px", // 👈 this pushes content below navbar
                backgroundColor: "#f9f9f9",
            }}
        >
            <div style={{ width: "100%", maxWidth: "400px" }}>
                <h2 className="text-center mb-4">Admin Login</h2>
                <input
                    type="email"
                    className="form-control mb-3"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="password"
                    className="form-control mb-3"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button className="btn btn-primary w-100" onClick={loginHandler}>
                    Login
                </button>
            </div>
        </div>
    );
};

export default AdminLogin;
